const { isRawResponse } = require('./isRawResponse');

module.exports = {
  isRawResponse,
};
